// extracted by mini-css-extract-plugin
export default {"hideOnArticleScroll":"HideOnArticleScroll_hideOnArticleScroll__2BRg-","isHidden":"HideOnArticleScroll_isHidden__LeK7Z"};